import { useState } from 'react';

import { ReactNode } from 'react';
import { DnDContext, DnDContextDataType } from './DnDContext';

export const DnDProvider = ({ children }: { children: ReactNode }) => {
  const [data, setData] = useState<DnDContextDataType>({
    type: 'shape',
    shape: 'square',
    width: 0,
    height: 0,
  });

  return (
    <DnDContext.Provider value={{ data, setData }}>
      {children}
    </DnDContext.Provider>
  );
};

export default DnDProvider;
